import { useQuery, useMutation } from '@tanstack/react-query';

// Services
import { getGlobalFilters, postGlobalFilters } from './globalFiltersService';

export const GLOBAL_FILTERS_QUERY_KEY = 'globalFilters';

/**
 * React Query mutation key for global filters POST (per page path).
 * Used with `useIsMutating` to gate table fetches until the mutation settles.
 * @param {string} path - Page path
 * @returns {import('@tanstack/react-query').MutationKey}
 */
export const globalFiltersMutationKey = (path) => ['globalFilters', path];

/**
 * Get manager global filters
 * @param {{path: string}} [params = {}] - The query params
 * @param {QueriesOptions} [options = {}] - The query options
 * @returns {import('@tanstack/react-query').UseQueryResult<ApiManagerGlobalFilters, Error>} The manager global filters
 */
export const useGlobalFilters = (params = { path: '' }, options = {}) => useQuery({
  queryKey: [GLOBAL_FILTERS_QUERY_KEY, params.path],
  queryFn: () => getGlobalFilters(params.path),
  ...options,
});

/**
 * Post manager global filters
 * @param {string} path - The path of the page
 * @param {import('@tanstack/react-query').UseMutationOptions<ApiManagerGlobalFiltersCreate, Error, ApiManagerGlobalFiltersCreate, unknown>} [options = {}] - The mutation options
 * @returns {import('@tanstack/react-query').UseMutationResult<ApiManagerGlobalFiltersCreate, Error, ApiManagerGlobalFiltersCreate, unknown>} The manager global filters mutation
 */
export const useGlobalFiltersMutation = (path, options = {}) => useMutation({
  mutationFn: (data) => postGlobalFilters(path, data),
  ...options,
});
